<div class="m-3">
  <div class="p-2 bg-white rounded flex flex-col shadow">
    <div class="text-lg font-bold">Carrier Scorecard <span class="text-blue-500">Past 7d</span></div>
    <div class="grid grid-cols-1 md:grid-cols-9 gap-3 mt-3">
      <div
        class="text-lg font-bold text-gray-600 ml-2 flex flex-row justify-start items-center cursor-pointer"
        (click)="setSortHeader('carrierName')"
      >
        Carrier
        <lohi-sort-indicator [activeColumn]="sortBy === 'carrierName'" [reversed]="sortReverse"></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 flex flex-row justify-start items-center cursor-pointer"
        (click)="setSortHeader('safetyScore')"
      >
        Safety Score
        <lohi-sort-indicator [activeColumn]="sortBy === 'safetyScore'" [reversed]="sortReverse"></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 flex flex-row justify-start items-center cursor-pointer"
        (click)="setSortHeader('missedCentsAverage')"
      >
        Missed Revenue Per Shift
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'missedCentsAverage'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 flex flex-row justify-start items-center cursor-pointer"
        (click)="setSortHeader('underAllocationPercent')"
      >
        Percent of Committed Trucks
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'underAllocationPercent'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 flex flex-row justify-start items-center cursor-pointer"
        (click)="setSortHeader('nightShiftsUnderAllocationPercent')"
      >
        Percent of Committed Trucks (Night Shift)
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'nightShiftsUnderAllocationPercent'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 flex flex-row justify-start items-center cursor-pointer"
        (click)="setSortHeader('weekendShiftsUnderAllocationPercent')"
      >
        Percent of Committed Trucks (Weekend)
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'weekendShiftsUnderAllocationPercent'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 flex flex-row justify-start items-center cursor-pointer"
        (click)="setSortHeader('missedShiftsTotal')"
      >
        Missed or Cancelled Shifts
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'missedShiftsTotal'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 flex flex-row justify-start items-center cursor-pointer"
        (click)="setSortHeader('rejectedLoadsTotal')"
      >
        Driver Declined Loads
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'rejectedLoadsTotal'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 flex flex-row justify-start items-center cursor-pointer"
        (click)="setSortHeader('prescheduledShiftsPercent')"
      >
        Shifts Booked In Advance
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'prescheduledShiftsPercent'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
    </div>
    <div
      class="grid grid-cols-1 md:grid-cols-9 py-2 gap-x-3 even:bg-gray-200"
      *ngFor="let carrier of carriers$ | async; trackBy: 'name' | trackByKey"
    >
      <div class="text-lg ml-2 font-bold">
        {{ carrier.isYou ? 'You' : (carrier.carrierName | dashIfNothing) }}
      </div>
      <div class="text-lg ml-2 justify-start items-center">
        {{ carrier.safetyScore || 'Coming Soon' }}
      </div>
      <div class="text-lg ml-2 justify-start items-center">
        {{ carrier.missedCentsAverage | currencyInPennies }}
      </div>
      <div
        class="text-lg ml-2 justify-start items-center"
        [ngClass]="{
          'text-red-500': 100 - carrier.underAllocationPercent < 80
        }"
      >
        {{ 100 - carrier.underAllocationPercent | number: '1.0-0' }}%
      </div>
      <div
        class="text-lg ml-2 justify-start items-center"
        [ngClass]="{
          'text-red-500': 100 - carrier.nightShiftsUnderAllocationPercent < 80
        }"
      >
        {{ 100 - carrier.nightShiftsUnderAllocationPercent | number: '1.0-0' }}%
      </div>
      <div
        class="text-lg ml-2 justify-start items-center"
        [ngClass]="{
          'text-red-500': 100 - carrier.weekendShiftsUnderAllocationPercent < 80
        }"
      >
        {{ 100 - carrier.weekendShiftsUnderAllocationPercent | number: '1.0-0' }}%
      </div>
      <div class="text-lg ml-2 justify-start items-center">{{ carrier.missedShiftsPercent | number: '1.0-0' }}%</div>
      <div class="text-lg ml-2 justify-start items-center">{{ carrier.rejectedLoadsPercent | number: '1.0-0' }}%</div>
      <div class="text-lg ml-2 justify-start items-center">
        {{ carrier.prescheduledShiftsPercent | number: '1.0-0' }}%
      </div>
    </div>
  </div>
  <div class="grid md:grid-cols-2 gap-3 mt-3">
    <div *ngIf="scheduling$ | async as sched">
      <lohi-missed-shifts [shifts]="sched.driverStats" [days]="sched.numberOfDays"> </lohi-missed-shifts>
    </div>
    <div *ngIf="driversRejected$ | async as stats">
      <lohi-loads-declined [loads]="stats.driverStats" [days]="stats.numberOfDays"> </lohi-loads-declined>
    </div>
    <div *ngIf="scheduling$ | async as sched">
      <lohi-booked-advance [shifts]="sched.driverStats" [days]="sched.numberOfDays"></lohi-booked-advance>
    </div>
    <div>
      <lohi-lost-earnings-by-driver-chart></lohi-lost-earnings-by-driver-chart>
    </div>
  </div>
</div>
